<div class="power">
  <enauka-simple-header></enauka-simple-header>
  <section class="container logowanie">
    <div class="card mb-3" *ngIf="grupaDziekanska">
      <div class="card-body">
        <h2 class="text-center">{{grupaDziekanska.kurs.nazwa}}</h2>
        <p class="lead text-center">
          {{grupaDziekanska.kurs.opis}}
        </p>
      </div>
    </div>
    <enauka-login></enauka-login>
  </section>
</div>
